const EniIcon = () => {
  return (
    <svg
      width="37"
      height="25"
      viewBox="0 0 37 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 0H36.3997V24.266H0V0Z" fill="#00269A" />
      <path
        d="M12.2812 8.901V11.93H15.5832V12.905H12.2812V16.025H15.9732V17H11.0982V7.926H15.9732V8.901H12.2812ZM24.8872 17H23.7042L18.9462 9.785V17H17.7632V7.926H18.9462L23.7042 15.128V7.926H24.8872V17Z"
        fill="white"
      />
    </svg>
  );
};

export default EniIcon;
